<template>
  <v-tooltip bottom max-width="500" :disabled="!isAiButtonDisabled">
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <ui-button
          color="primary"
          outlined
          :icon="icon"
          :disabled="isAiButtonDisabled"
          @click="$emit('ai-reply')"
        >
          {{ label }}
        </ui-button>
      </div>
    </template>
    <span>{{ disabledAiButtonTooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "review-ai-button",
  props: {
    isAiButtonDisabled: {
      type: Boolean,
      default: false
    },
    disabledAiButtonTooltip: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  }
};
</script>
